/** Whether the editor's timeline panel is open (desktop and mobile share the toggle). */
export const isTimelineModeOn = (): boolean => {
  return window.PMW.redux.store.getState().posterEditor.isTimelineModeOn === true;
};
